var transitionFadeInSlide = function transitionFadeInSlide(options) {
  var layerSide = options.layerSide,
    transitionDelay = options.transitionDelay,
    transitionDuration = options.transitionDuration,
    transitionStatus = options.transitionStatus;
  var translateY = layerSide === 'bottom' ? '-10px' : '10px';
  switch (transitionStatus) {
    case 'entered':
      {
        return {
          opacity: 1,
          transform: 'translateY(0)',
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, transform ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms")
        };
      }
    case 'entering':
      {
        return {
          opacity: 1,
          transform: 'translateY(0)',
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, transform ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms")
        };
      }
    case 'exited':
      {
        return {
          opacity: 0,
          transform: "translateY(".concat(translateY, ")"),
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, transform ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms")
        };
      }
    case 'exiting':
      {
        return {
          opacity: 0,
          transform: "translateY(".concat(translateY, ")"),
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, transform ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms")
        };
      }
    default:
      {
        // unmounted
        return {
          opacity: 0,
          transform: "translateY(".concat(translateY, ")")
        };
      }
  }
};
export { transitionFadeInSlide };